<template>
  <div class="huidisesad">
    <van-sticky>
      <div class="beijingse" v-if="!shows"></div>
      <img
        src="../assets/img/wdl.png"
        class="img"
        width="100%"
        v-if="!token && isHaveRight == 0 && shows"
        @click="log"
      />
      <img
        src="../assets/img/wqx.png"
        class="img"
        width="100%"
        v-if="token && isHaveRight == 0 && shows"
      />
      <img
        :src="require($route.query.id == 10086 ? '../assets/img/qingfeng_zhibofengmian.jpg' : '../assets/img/wks.png')"
        class="img"
        width="100%"
        v-if="
          liveStatus == 2 &&
          videoVoList.length == 0 &&
          isHaveRight == 1 &&
          shows
        "
      />
      <img
        src="../assets/img/js.png"
        class="img"
        width="100%"
        v-if="
          liveStatus == 3 &&
          videoVoList.length == 0 &&
          isHaveRight == 1 &&
          shows
        "
      />
      <img
        src="../assets/img/js.png"
        class="img"
        width="100%"
        v-if="
          liveStatus == 3 &&
          showsdd&&token&&isHaveRight != 0
        "
      />
      <img
        :src="require($route.query.id == 10086 ? '../assets/img/qingfeng_zhibofengmian.jpg' : '../assets/img/wks.png')"
        class="img"
        width="100%"
        v-if="
          liveStatus == 2 &&
          showsdd&&token&&isHaveRight != 0
        "
      />
      <div v-if="isHaveRight == 1 && shows&&!showsdd">
        <video-player
          v-if="liveStatus == 1 || liveStatus == 4 || videoVoList.length > 0"
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @ended="onPlayerEnded($event)"
          @play="onPlayerPlay($event)"
        >
        </video-player>
      </div>
      <!-- <div style="    position: absolute;top: 0%;"><img src="../assets/img/ming.png" width="100%"/></div> -->
      <van-row class="pin weihsu">
        <van-col span="8">
          <!-- <span class="feihuis">
            <img src="../assets/img/kan.png" height="15px" />{{
              lessonViewnum > 10000
                ? chuxiao(lessonViewnum) + "万"
                : lessonViewnum
            }}
          </span> -->
        </van-col>
        <van-col span="8">
          <!-- <span class="feihuis">
            <img src="../assets/img/zan.png" height="15px" />{{
              lessonZannum > 10000 ? chuxiao(lessonZannum) + "万" : lessonZannum
            }}
          </span> -->
        </van-col>
        <van-col span="8" @click="showShare = true">
          <span class="feihuis">
            <img src="../assets/img/fen.png" height="15px"/>分享
          </span>
        </van-col>
      </van-row>
      <div
        class="pin"
        style="
          background-color: #fff;
          margin-top: 10px;
          padding-bottom: 7px;
          border-bottom: 1px solid #eee;
        "
      >
        <span
          @click="onClick(2)"
          class="yansex mohjui"
          :class="name == 2 ? 'dazitis' : ''"
          v-if="commentsIsOpen == 1"
        >讨论</span
        >
        <span
          @click="onClick(3)"
          class="yansex mohjui"
          :class="name == 3 ? 'dazitis' : ''"
          v-if="spectatorIsOpen == 1"
        >观众</span
        >
        <span
          @click="onClick(0)"
          class="yansex mohjui"
          :class="name == 0 ? 'dazitis' : ''"
        >详情</span
        >
        <span
          v-if="videoVoList.length > 0"
          @click="onClick(1)"
          class="yansex mohjui"
          :class="name == 1 ? 'dazitis' : ''"
        >目录</span
        >
        <span
          v-if="resList && resList.length > 0"
          @click="onClick(4)"
          class="yansex mohjui"
          :class="name == 4 ? 'dazitis' : ''">
          课件
        </span>
      </div>
    </van-sticky>
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click="show = true">
        <div
          id="qrcode"
          class="qrcode"
          ref="qrCodeUrl"
          style="margin: 0px auto; border: 15px solid rgb(255, 255, 255)"
        ></div>
        <!-- <div class="huifs">长按保存二维码</div> -->
      </div>
    </van-overlay>
    <div class="pin" style="background-color: #fff; margin: 0 0 10px 0">
      <div style="background-color: #fff; margin: 10px 0">
        <div v-if="name == 0 && courseFeature" class="yuehussdfd">
          <div>课后反思：</div>
          {{ courseFeature }}
        </div>
        <div v-if="name == 0" v-html="courseInfo" class="yuehussdfd"></div>
        <div v-if="name == 1" class="yuehussdfd">
          <van-collapse v-model="chehui">
            <van-collapse-item
              :title="i+1+'、'+item.lessonName"
              :name="i"
              v-for="(item, i) in videoVoList"
              :key="i"
            >
              <div
                v-for="(list, index) in item.videoVoList?item.videoVoList:[]"
                :key="index"
                :class="playerOptions.sources[0].src==list.serverHttp+list.fileUrl ? 'sehuang' : 'huisedi'"
                @click="dianbo(index, i,item.lessonLimit,item.isHaveRight)"
              >
              <span v-if="item.liveStatus==4||item.liveStatus==1">
                <span
                >回放</span
                >
              </span>
                <span v-if="item.liveStatus==2">
                <span
                >未开始</span
                >
              </span>
                <span v-if="item.liveStatus==3">
                <span
                >已结束</span
                >
              </span>
                <!-- <span v-if="item.liveStatus==1">
                  <span
                    >正在直播</span
                  >
                </span> -->
                <!-- <span class="miuyuif">{{
                  slice(list.beginTime, list.endTime)
                }}</span> -->
                <span class="miuyuif">{{ list.videoTitle }}</span>
                <div
                  v-if="list.lessonLimit == 1 && list.isHaveRight == 1"
                  class="kanshijuf"
                >
                  试看
                </div>
                <div
                  v-if="list.lessonLimit == 0 && list.isHaveRight == 0"
                  class="kanshijuf1"
                >
                  授权观看
                </div>
              </div>
              <div
                v-if="item.liveStatus==1"
                :class="playerOptions.sources[0].src==item.rtmpUrl? 'sehuang' : 'huisedi'"
                @click="dianbos( 0,i,item.lessonLimit,item.isHaveRight)"
              >
              <span v-if="item.liveStatus==2">
                <span
                >未开始</span
                >
              </span>
                <span v-if="item.liveStatus==3">
                <span
                >已结束</span
                >
              </span>
                <span v-if="item.liveStatus==1">
                <span
                >正在直播</span
                >
              </span>
                <span class="miuyuif">{{
                    slice(item.beginTime, item.endTime)
                  }}</span>
                <span class="miuyuif">{{ item.videoTitle }}</span>
                <div
                  v-if="item.lessonLimit == 1 && item.isHaveRight == 1"
                  class="kanshijuf"
                >
                  试看
                </div>
                <div
                  v-if="item.lessonLimit == 0 && item.isHaveRight == 0"
                  class="kanshijuf1"
                >
                  授权观看
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div
          v-if="name == 2 && commentsIsOpen == 1"
          style="padding-bottom: 40px"
        >
          <van-cell v-for="(item, index) in itemLists" :key="index" id="page">
            <div>
              <img
                v-if="item.userHeadImg && item.userHeadImg !== null"
                :src="item.userHeadImg"
                style="vertical-align: text-top"
                class="imghuif"
              /><img
              v-else
              src="../assets/img/motouxiang.png"
              style="vertical-align: text-top"
              class="imghuif"
            /><span class="cohuis">{{ item.userName }}</span>
              <span class="feihuis rlji">
                <span class="shanchus" @click="shanchu(item)">删除</span>
                <span>未精选</span>
              </span>
            </div>
            <div class="mahjufas">{{ item.feelingContent }}</div>
          </van-cell>
          <div class="jkfkasfasf" v-if="itemLists.length > 0">
            ——以上评论被精选后，可被所有人看到——
          </div>
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="10"
          >
            <van-cell v-for="(item, index) in itemList" :key="index">
              <div>
                <img
                  v-if="item.userHeadImg && item.userHeadImg !== null"
                  :src="item.userHeadImg"
                  style="vertical-align: text-top"
                  class="imghuif"
                /><img
                v-else
                src="../assets/img/motouxiang.png"
                style="vertical-align: text-top"
                class="imghuif"
              /><span class="cohuis">{{ item.userName }}</span
              ><span class="feihuis rlji">
                  <img
                    src="../assets/img/xin.png"
                    v-if="shifouzai(item.likeList) == 0"
                    style="vertical-align: middle"
                    width="15px"
                    @click="lessonfeelingzan(item.feelingId, index)"
                  />
                  <img
                    src="../assets/img/hxin.png"
                    v-else
                    style="vertical-align: middle"
                    width="15px"
                    @click="lessonfeelingcancelZan(item.feelingId, index)"
                  />
                  {{
                  item.praseCount > 10000
                    ? item.praseCount / 10000 + "万"
                    : item.praseCount
                }}
                </span>
              </div>
              <div class="mahjufas">
                {{ item.feelingContent }}
                <span class="zhiding" v-if="item.isTop == 1">置顶</span>
              </div>
            </van-cell>
          </van-list>
          <div class="dibus">
            <div class="hjuisfg">
              <van-cell-group
                v-if="
                  visitorIsOpen == 0
                    ? token
                    : shows && isHaveRight == 1 && shows
                "
              >
                <div class="hjuisgagd" @click="buildBoard">
                  评论被精选后，可被所有人看到
                </div>
                <span
                  class="hjuisga"
                  style="margin-top: -30px; margin-right: 20px"
                >
                  <img src="../assets/img/fayan.png" width="20px"/>
                </span>
              </van-cell-group>
              <van-cell-group
                v-if="!token"
                :class="visitorIsOpen == 1 ? 'huisesf' : ''"
              >
                <div class="hjuisgagd">
                  登录后一起参与互动发言吧
                  <span
                    style="margin-right: -20px"
                    class="hjuisga jinru"
                    @click="log"
                  >登录</span
                  >
                </div>
              </van-cell-group>
              <van-cell-group v-if="isHaveRight == 0">
                <div class="hjuisgagd">暂时没有权限，请联系管理员！</div>
              </van-cell-group>
            </div>
          </div>
        </div>
        <div
          v-if="name == 3 && spectatorIsOpen == 1"
          style="padding-bottom: 40px"
        >
          <div class="jkfkasfasf" v-if="guanlist.length > 0">
            <img
              src="../assets/img/wm.png"
              height="15px"
              style="vertical-align: middle"
            />
            直播间人数：{{ guanlist.length }}
          </div>
          <van-cell v-for="(item, index) in guanlist" :key="index">
            <div>
              <img
                v-if="item.avatarUrl && item.avatarUrl !== null"
                :src="item.avatarUrl"
                style="vertical-align: middle"
                class="imghuif"
              /><img
              v-else
              src="../assets/img/motouxiang.png"
              style="vertical-align: middle"
              class="imghuif"
            /><span class="cohuis heiseffa">{{ item.viewersName }}</span>
              <span class="cohuis">（{{ item.schoolName }}）</span>
            </div>
          </van-cell>
          <div class="jkfkasfasf" v-if="guanlist.length == 0">
            暂时没有观众观看
          </div>
        </div>
        <div v-if="name === 4" style="padding-bottom: 40px;">
          <van-row
            gutter="10"
            class="mag"
            v-for="(list, index) in resList"
            :key="index"
          >
            <van-col span="4" class="famous-teacher-studio-img-row">
              <img
                :src="list.serverHttp + 'Icon/' + list.fileFormat + '.png'"
                width="100%"
                style="width: auto; max-height: 40px; border-radius: 5px;"
              />
            </van-col>
            <van-col span="20">
              <van-col span="24" style="max-width: 100%;">
                <wx-open-launch-weapp
                  appid="wx8fb5fc6abd9a9ebb"
                  :path="list.fileUrl"
                >
                  <script type="text/wxtag-template">
                    <div
                      style="font-size: 14px !important;font-weight: bold; display: inline-block; float: left; margin-right: 10px;">
                      {{ list.fileName }}
                    </div>
                  </script>
                </wx-open-launch-weapp>
              </van-col>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <!-- <div v-html="courseInfo" class="yuehussdfd"></div> -->
    <div class="fifgj">
      <div class="demo"></div>
      <span class="feihuis" @click="diazan">
        <img src="../assets/img/zans.png" width="44px"/>
      </span>
    </div>
    <van-action-sheet v-model="showlisy">
      <div class="content">
        <van-row style="padding: 15px 10px">
          <van-col span="8">
            <van-icon name="cross" @click="showlisy = false"/>
          </van-col>
          <van-col span="8" style="text-align: center"> 写评论</van-col>
          <van-col span="8" style="margin-top: 5px">
            <span
              class="hjuisga"
              style="color: rgb(0 102 255 / 69%)"
              @click="fasong"
            >提交</span
            >
          </van-col>
        </van-row>
        <van-field
          v-model="value"
          rows="5"
          autosize
          ref="inputID"
          type="textarea"
          placeholder="评论被精选后，可被所有人看到"
          show-word-limit
        />
      </div>
    </van-action-sheet>
    <div :class="chuxian == 0 ? 'huisesf' : 'moon'">
      当前直播支持讨论，快来试试吧！
    </div>
  </div>
</template>

<script>
import {
  courseid,
  lessonzan,
  lessonview,
  wxgetWeixinQrUrl,
  lessongetLiveStatus,
  declareintoInsert,
  declarequitUpate,
  siteurl,
  note,
  lessonfeelinglist,
  lessonfeeling,
  declareviewerWatchRecord,
  lessonfeelingid,
  lessonfeelingzan,
  lessonfeelingcancelZan,
} from "@/api/home";
import "video.js/dist/video-js.css";
import {videoPlayer} from "vue-video-player";
import "videojs-contrib-hls";
import QRCode from "qrcodejs2";
import {Toast} from "vant";

export default {
  data() {
    return {
      playerOptions: {
        live: true,
        autoplay: true,
        // muted: true,
        // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        notSupportedMessage: "",
        poster: require("../assets/img/kai.png"),
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
        // type: "video/mp4",
        sources: [
          {
            type: "",
            src: "",
          },
        ],
      },
      options: [
        {name: "分享海报", icon: require("../assets/img/img.png")},
        {name: "二维码", icon: require("../assets/img/er.png")},
      ],
      showShare: false,
      show: false,
      showlisy: false,
      liveStatus: 2,
      showsdd: false,
      shows: false,
      resList: [],
      courseInfo: "",
      lessonZannum: 0,
      lessonViewnum: 0,
      courseName: "",
      name: 0,
      videoVoList: "",
      fang: "",
      wxurl: "",
      isHaveRight: "",
      token:
        localStorage.getItem("token") == ""
          ? false
          : localStorage.getItem("token"),
      roomType: "",
      lhuid: "",
      courseFeature: "",
      roleType: localStorage.getItem("roleType"),
      userId: localStorage.getItem("userId"),
      courseIdid: "",
      curPage: 1,
      itemList: [],
      loading: false,
      finished: false,
      total: 0,
      value: "",
      itemLists: [],
      commentsIsOpen: 0,
      guanlist: [],
      loadings: false,
      finisheds: false,
      pageNum: 1,
      timer1: null,
      spectatorIsOpen: 0,
      unmlisy: 0,
      timer: null,
      viewTimer: null,
      visitorIsOpen: 0,
      chuxian: 0,
      fang1: 0,
      chehui: [],
    };
  },
  watch: {
    liveStatus() {
      this.courseid();
    },
    roomType() {
      if (this.roomType == 3 && this.isHaveRight == 1) {
        this.declareintoInsert();
      }
    },
    name() {
      let that = this;
      if (that.liveStatus == 1) {
        if (that.name == 3) {
          that.declareviewerWatchRecord();
          that.timer1 = setInterval(() => {
            that.declareviewerWatchRecord();
          }, 300000);
        } else {
          if (that.name == 2) {
            that.itemList = [];
            that.curPage = 1;
            that.lessonfeelinglist();
            that.lessonfeelinglists();
          }
          clearInterval(that.timer1);
        }
      }
    },
    commentsIsOpen() {
      if (this.commentsIsOpen !== 1 && this.name == 2) {
        this.name = 0;
      }
    },
    spectatorIsOpen() {
      if (this.spectatorIsOpen !== 1 && this.name == 3) {
        this.name = 0;
      }
    },
  },
  components: {videoPlayer},
  methods: {
    buildBoard() {
      this.showlisy = true;
      this.$nextTick(() => {
        this.$refs.inputID.focus();
      });
    },
    slice(s, d) {
      return s.slice(10, 16) + " -" + d.slice(10, 16);
    },
    onClick(s) {
      this.name = s;
    },
    onPlayerEnded($event) {
      console.log(player);
    },
    creatQrCode() {
      document.getElementById("qrcode").innerHTML = "";
      var integrityurl = this.wxurl;
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: integrityurl, // 需要转换为二维码的内容
        render: "canvas",
        width: 120,
        height: 120,
        colorDark: "#FF6D4E",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      var canvas = document.getElementsByTagName("canvas")[0];
      var img = convertCanvasToImage(canvas);
      $("#qrcode").html(img); // 添加DOM
      //从 canvas 提取图片 image
      function convertCanvasToImage(canvas) {
        //新建Image对象
        var image = new Image();
        // canvas.toDataURL 返回的是一串Base64编码的URL
        image.src = canvas.toDataURL("image/png");
        return image;
      }
    },
    onSelect(option) {
      if (option.name == "二维码") {
        this.show = true;
        this.creatQrCode();
      } else {
        this.$router.push({
          path: "/poster",
          query: {
            id: this.$route.query.id,
            url: this.wxurl,
          },
        });
      }
      this.showShare = false;
    },
    lessongetLiveStatus() {
      let that = this;
      let params = {
        lessonId: this.$route.query.id,
      };
      if (this.$route.query.id == undefined) {
        return false;
      }
      lessongetLiveStatus(params)
        .then((res) => {
          that.liveStatus = res.data.data.liveStatus;
          that.commentsIsOpen = res.data.data.commentsIsOpen;
          that.spectatorIsOpen = res.data.data.spectatorIsOpen;
          that.visitorIsOpen = res.data.data.visitorIsOpen;
          that.lessonViewnum = res.data.data.viewNum;
          that.lessonZannum = res.data.data.zanNum;
        })
        .catch(() => {
        });
    },
    courseid() {
      let that = this;
      let params = {
        id: this.$route.query.id,
      };
      if (this.$route.query.id == undefined) {
        return false;
      }
      courseid(params)
        .then((res) => {
          that.courseIdid = res.data.data.courseId;
          that.liveStatus = res.data.data.liveStatus;
          that.courseName = res.data.data.netClassCourseVo.courseName;
          document.title = that.courseName;
          that.courseFeature = res.data.data.netClassCourseVo.courseFeature;
          that.courseInfo = res.data.data.netClassCourseVo.courseInfo;
          that.resList = res.data.data.netClassCourseVo.resList;
          // that.videoVoList =
          //   res.data.data.videoVoList == null ? [] : res.data.data.videoVoList;
          that.videoVoList =
            res.data.data.netClassCourseVo.lessonVos == null
              ? []
              : res.data.data.netClassCourseVo.lessonVos;
          that.isHaveRight = res.data.data.isHaveRight;
          that.shows = true;
          if (that.unmlisy == 0) {
            that.unmlisy = 1;
            clearInterval(that.timer);
            that.timer = setInterval(() => {
              that.lessongetLiveStatus();
            }, 60000);
            for (var i = 0; i < that.videoVoList.length; i++) {
              if (that.$route.query.id == that.videoVoList[i].lessonId) {
                if (that.videoVoList[i].liveStatus == 1) {
                  that.playerOptions.sources[0].type = "application/x-mpegURL";
                  that.playerOptions.sources[0].src = res.data.data.rtmpUrl;
                  that.fang = i
                  that.fang1 = 0
                  that.chehui.push(i)
                  if (that.token) {
                    that.note();
                  }
                  if (that.commentsIsOpen == 1) {
                    setTimeout(function () {
                      that.chuxian = 1;
                    }, 300000);
                  }
                } else {
                  if (that.videoVoList[i].videoVoList.length > 0) {
                    that.chehui.push(i)
                    that.playerOptions.sources[0].type = "video/mp4";
                    that.playerOptions.sources[0].src =
                      that.videoVoList[i].videoVoList[0]
                        .serverHttp +
                      that.videoVoList[i].videoVoList[0].fileUrl;
                    that.name = 1;
                    if (that.token) {
                      that.note();
                    }
                    setInterval(() => {
                      clearInterval(that.timer);
                    }, 600000);
                  } else {
                    that.playerOptions.sources[0].type = "";
                    that.playerOptions.sources[0].src = "";
                    that.showsdd = true
                  }
                }
              }
            }
            if (that.name != 1 && that.liveStatus == 2) {
              that.playerOptions.sources[0].type = "";
              that.playerOptions.sources[0].src = "";
              that.showsdd = true
            }
            if (that.liveStatus == 3) {
              that.playerOptions.sources[0].type = "";
              that.playerOptions.sources[0].src = "";
              that.showsdd = true
            }
            that.roomType = res.data.data.roomType;
          }
          clearInterval(that.viewTimer);
          if (
            that.roomType === 3 &&
            that.playerOptions.sources[0].src &&
            that.isHaveRight === 1
          ) {
            that.viewTimer = setInterval(() => {
              that.declarequitUpate();
            }, 60000);
          }
        })
        .catch(() => {
        });
    },
    dianbo(d, s, z, k) {
      let that = this
      this.fang1 = d;
      this.fang = s;
      this.lessonLimit = z
      this.isHaveRight = k
      that.playerOptions.sources[0].type = "video/mp4";
      that.playerOptions.sources[0].src =
        that.videoVoList[that.fang].videoVoList[that.fang1].serverHttp +
        that.videoVoList[that.fang].videoVoList[that.fang1].fileUrl;
      that.name = 1;
      this.showsdd = false
      // this.fang1 = d;
      // this.fang=s
      //   this.playerOptions.sources[0].src =
      //     this.videoVoList[this.fang].videoVoList[this.fang1].serverHttp+
      //     this.videoVoList[this.fang].videoVoList[this.fang1].fileUrl;
    },
    dianbos(d, s, z, k) {
      let that = this
      // this.fang1 = d;
      this.fang = s;
      this.lessonLimit = z
      this.isHaveRight = k
      that.playerOptions.sources[0].type = "application/x-mpegURL";
      that.playerOptions.sources[0].src = this.videoVoList[this.fang].rtmpUrl;
    },
    onPlayerPlay(player) {
      player.play();
    },
    diazan() {
      let that = this;
      let params = {
        lessonId: this.$route.query.id,
      };
      lessonzan(params)
        .then((res) => {
          // Toast('点赞成功！')
          var x = 100;
          var y = 100;
          var num = Math.floor(Math.random() * 3 + 1);
          var index = $(".demo").children(".imgsd").length;
          var rand = parseInt(Math.random() * (x - y + 1) + y);

          $(".demo").append("<img src='' class='imgsd'>");
          $(".imgsd:eq(" + index + ")").attr(
            "src",
            "https://xm-evaluate-file.oss-cn-beijing.aliyuncs.com/Image/2021-06/QFdFIy3d1k.png"
          );
          $(".imgsd").animate(
            {
              bottom: "1500px",
              opacity: "0",
              left: rand,
            },
            5000
          );
          that.lessonZannum++;
        })
        .catch(() => {
        });
    },
    lessonview() {
      let that = this;
      let params = {
        lessonId: this.$route.query.id,
      };
      lessonview(params)
        .then((res) => {
          that.lessonViewnum++;
        })
        .catch(() => {
        });
    },
    wxgetWeixinQrUrl() {
      let that = this;
      let params = {
        resLessonId: this.$route.query.id,
      };
      if (this.$route.query.id == undefined) {
        return false;
      }
      wxgetWeixinQrUrl(params)
        .then((res) => {
          that.wxurl = res.data.data;
        })
        .catch(() => {
        });
    },
    log() {
      // this.$router.push({
      //   path: "/log",
      // });
      let local = siteurl + "#/log";
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri=" +
        encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect";
    },
    declareintoInsert() {
      let that = this;
      let params = {
        lessonId: this.$route.query.id,
        wxOpenid: localStorage.getItem("openid"),
      };
      declareintoInsert(params)
        .then((res) => {
          // that.wxurl=res.data.data
        })
        .catch(() => {
        });
    },
    declarequitUpate() {
      let that = this;
      let params = {
        lessonId: this.lhuid,
        wxOpenid: localStorage.getItem("openid"),
      };
      declarequitUpate(params)
        .then((res) => {
          // that.wxurl=res.data.data
        })
        .catch(() => {
        });
    },
    note() {
      let that = this;
      let params = {
        courseId: this.courseIdid,
        lessonId: this.lhuid,
        roleType: that.roleType,
        userId: that.userId,
      };
      note(params)
        .then((res) => {
          // that.loading = false
        })
        .catch(() => {
          // that.loading = false
        });
    },
    lessonfeelinglist() {
      let that = this;
      let params = {
        curPage: this.curPage,
        lessonId: this.lhuid,
        pageSize: 10,
        replyStatus: 1,
      };
      lessonfeelinglist(params)
        .then((res) => {
          that.loading = false;
          let data = res.data.data.dataList;
          that.total = res.data.data.totalCount;
          if (data == null || data.length == 0) {
            that.finished = true;
            return;
          }
          that.itemList = that.itemList.concat(data);
          if (that.itemList.length >= that.total) {
            that.finished = true;
          }
        })
        .catch(() => {
          that.loading = false;
        });
    },
    lessonfeelinglists() {
      let that = this;
      let params = {
        curPage: 1,
        lessonId: this.lhuid,
        pageSize: 100,
        replyStatus: 0,
        sourceId: localStorage.getItem("openid"),
      };
      lessonfeelinglist(params)
        .then((res) => {
          that.itemLists = res.data.data.dataList;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    onLoad() {
      this.curPage++;
      this.lessonfeelinglist();
    },
    fasong() {
      let that = this;
      if (that.visitorIsOpen == 1) {
      } else {
        Toast("登录后才能评论！");
        return false;
      }
      if (that.value == "") {
        Toast("请输入内容！");
        return false;
      }
      let params = {
        courseId: this.courseIdid == "" ? this.lhuid : this.courseIdid,
        lessonId: this.lhuid,
        feelingContent: that.value,
        sourceId: localStorage.getItem("openid"),
      };
      that.showlisy = false;
      lessonfeeling(params)
        .then((res) => {
          that.lessonfeelinglists();
          var PageId = document.querySelector("#page");
          window.scrollTo({
            top: PageId.offsetTop - 300,
            behavior: "smooth",
          });
          that.value = "";
          that.showlisy = false;
        })
        .catch(() => {
        });
    },
    declareviewerWatchRecord() {
      let that = this;
      let params = {
        pageNum: that.pageNum,
        lessonId: that.lhuid,
        pageSize: 10000,
      };
      declareviewerWatchRecord(params)
        .then((res) => {
          // that.loadings = false;
          that.guanlist = res.data.data.dataList;
          // let data = res.data.data.dataList;
          // let total = res.data.data.totalCount;
          // if (data == null || data.length == 0) {
          //   that.finisheds = true;
          //   return;
          // }
          // that.guanlist = that.guanlist.concat(data);
          // if (that.guanlist.length >= total) {
          //   that.finisheds = true;
          // }
        })
        .catch(() => {
          that.loadings = false;
        });
    },
    onLoads() {
      this.pageNum++;
      this.declareviewerWatchRecord();
    },
    shanchu(s) {
      let that = this;
      let params = {
        feelingId: s.feelingId,
      };
      lessonfeelingid(params)
        .then((res) => {
          that.lessonfeelinglists();
        })
        .catch(() => {
        });
    },
    shifouzai(s) {
      let unm = 0;
      let sourceId = localStorage.getItem("openid");
      for (var i = 0; i < s.length; i++) {
        if (s[i].userId == this.userId || sourceId == this.userId) {
          unm = 1;
        }
      }
      return unm;
    },
    lessonfeelingzan(s, d) {
      let that = this;
      // if (that.token) {
      //   Toast("登录后才能点赞哦！");
      //   return false;
      // }
      let params = {
        feelingId: s,
        sourceId: localStorage.getItem("openid"),
      };
      lessonfeelingzan(params)
        .then((res) => {
          let list = {
            userId: localStorage.getItem("openid"),
          };
          if (res.data.code == 200) {
            that.itemList[d].praseCount = that.itemList[d].praseCount + 1;
          }
        })
        .catch(() => {
        });
    },
    lessonfeelingcancelZan(s, d) {
      let that = this;
      // if (!this.token) {
      //   Toast("登录后才能取消点赞哦！");
      //   return false;
      // }
      let params = {
        feelingId: s,
        sourceId: localStorage.getItem("openid"),
      };
      lessonfeelingcancelZan(params)
        .then((res) => {
          let list = that.itemList[d].likeList;
          for (var i = 0; i < list.length; i++) {
            if (list[i].userId == that.userId) {
              list.splice(i, 1);
            }
          }
          that.itemList[d].likeList = list;
        })
        .catch(() => {
        });
    },
    chuxiao(s) {
      let list = s / 10000;
      return list.toFixed(2);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
    clearInterval(this.viewTimer);
    if (
      this.roomType == 3 &&
      this.playerOptions.sources[0].src !== "" &&
      this.isHaveRight == 1
    ) {
      this.declarequitUpate();
    }
  },
  destroyed() {
    // this.declarequitUpate()
  },
  mounted() {
    this.lhuid = this.$route.query.id;
    this.courseid();
    this.lessonview();
    this.wxgetWeixinQrUrl();
    this.lessongetLiveStatus();
    this.lessonfeelinglists();
    this.lessonfeelinglist();
    this.declareviewerWatchRecord();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/video.vue